export const salaryFields = ['hourly_rate', 'daily_rate', 'full_hours_salary', 'nominal_salary', 'net_salary'];
export function money(value) {
  if (value === null || value === undefined || value === '' || !Number.isFinite(Number(value))) return '—';
  return '$ ' + Number(value).toLocaleString('es-UY', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}
